enum LoginActions {
  LOGIN = "loginModule/LOGIN",
  LOGIN_SUCCESS = "loginModule/LOGIN_SUCCESS",
  LOGIN_FAILURE = "loginModule/LOGIN_FAILURE",
  CHANGE_PASSWORD = "loginModule/CHANGE_PASSWORD",
  CHANGE_PASSWORD_SUCCESS = "loginModule/CHANGE_PASSWORD_SUCCESS",
  CHANGE_PASSWORD_FAILURE = "loginModule/CHANGE_PASSWORD_FAILURE",
  LOGOUT = "loginModule/LOGOUT",
}

enum LoginGetters {
  GET_IS_LOGIN_MODE = "loginModule/GET_IS_LOGIN_MODE",
  GET_PASSWORD_POLICY = "loginModule/GET_PASSWORD_POLICY",
  GET_ERROR_MESSAGE = "loginModule/GET_ERROR_MESSAGE",
  GET_ERROR_TIMEOUT = "loginModule/GET_ERROR_TIMEOUT"
}

enum LoginMutations {
  SET_ERROR_MESSAGE = "SET_ERROR_MESSAGE",
  SET_LOCKED_MESSAGE = "SET_LOCKED_MESSAGE",
  DELETE_ERROR_MESSAGE = "DELETE_ERROR_MESSAGE",
  SET_PASSWORD_EXPIRED = "SET_PASSWORD_EXPIRED",
}

export {
  LoginActions,
  LoginGetters,
  LoginMutations,
}
